import React, { Fragment } from "react";

import DynamicTitleWithTooltip from "../components/DynamicTitleWithTooltip";
import Form from "./Form";
import Location from "./Location";
import { Edit as RaEdit } from "react-admin";
import useManageOpenEditTabs from "../components/useManageOpenEditTabs";
import useSearchParams from "./useSearchParams";

const getLocationTitle = (record, translate) =>
  `${translate("resources.location.types.location")} ${record.id} (${
    record.name
  })`;

const Edit = (props) => {
  const searchParams = useSearchParams({ ...props });

  const id = props.id?.toString(); // ID della risorsa
  useManageOpenEditTabs(props.resource, id);
  return (
    <Fragment>
      <Location divider={false} id={searchParams.get("parent_id")} />
      <RaEdit
        {...props}
        undoable={false}
        title={<DynamicTitleWithTooltip getTitle={getLocationTitle} />}
      >
        <Form location={props.location} edit />
      </RaEdit>
    </Fragment>
  );
};
export default Edit;
